import React, { ReactElement } from 'react';
import { getLabelFallback } from '@utils/utils';
import { useSelector } from 'react-redux';

import ProcessStepTracker from '@components/ProcessStepTracker';

import Logo from '@images/svg-icons/logo.svg';
import ArrowLeft from '@images/svg-icons/arrow_left.svg';

type CheckoutHeaderProps = {
    handleBack: () => void;
    stepNumber: number;
}

const CheckoutHeader = (props: CheckoutHeaderProps) : ReactElement => {
    const {
        handleBack,
        stepNumber
    } = props;

    const isMobile = useSelector(state => state.cart.isMobile);

    return (
        <header className="checkout-header" aria-label={getLabelFallback('CHECKOUT_TOP_LABEL')}>
            <div className="checkout-header-content">
                <div className="checkout-header-content-back">
                    <button className="checkout-header-content-back-link back-link" onClick={() => handleBack()}><ArrowLeft /> {getLabelFallback('HEADER_BACK_LABEL')}</button>
                </div>
                <div className="checkout-header-content-logo">
                    <a href="/" title="Home">
                        <Logo width={isMobile ? 143 : 191} height={17} viewBox={"0 0 191 17"}/>
                    </a>
                </div>
                <div className="checkout-header-content-stepper">
                    <ProcessStepTracker stepNumber={stepNumber}/>
                </div>                
                <div className="checkout-header-content-claim">
                    <label>{ getLabelFallback('HEADER_CHECKOUT_TOP_LABEL') }</label>
                </div>
            </div>
        </header>
    );
}

export default CheckoutHeader;